import Component from "./AvatarsView";
import Avatar from "./components/Avatar/AvatarsViewAvatar";
import Items from "./components/Items/AvatarsViewItems";
import Link from "./components/Link/AvatarsViewLink";
import Text from "./components/Text/AvatarsViewText";

interface IAvatarsViewExtensions {
    Items: typeof Items;
    Text: typeof Text;
    Link: typeof Link;
    Avatar: typeof Avatar;
}

export const AvatarsView: typeof Component & IAvatarsViewExtensions =
    Object.assign(Component, {
        Items,
        Text,
        Link,
        Avatar,
    });

export type { AvatarsViewProps } from "./types";
